import { Link, NavLink } from '../../../node_modules/react-router-dom/index'
import './index.scss'
import LogoLightBulb from '../../assets/images/lightbulb.png'
import LogoSubtitle from '../../assets/images/julio-name.png'
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome/index'
import { faEnvelope, faHome, faUser } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index'
import { faLinkedin, faGithub, faGitlab } from '../../../node_modules/@fortawesome/free-brands-svg-icons/index'

const Sidebar = () => (
    <div className='nav-bar'>
        <Link className='logo' to='/'>
            <img src={LogoLightBulb} alt="logo" /> 
            <img className='sub-logo' src={LogoSubtitle} alt="Julio" />
        </Link>
        <nav>
            <NavLink exact="true" activeclassname="active" to="/">
                <FontAwesomeIcon icon={faHome} color="#4d4d4e"/>
            </NavLink>
            <NavLink exact="true" activeclassname="active" className="about-link" to="/about">
                <FontAwesomeIcon icon={faUser} color="#4d4d4e"/>
            </NavLink>
            <NavLink exact="true" activeclassname="active" className="contact-link" to="/contact">
                <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e"/>
            </NavLink>
        </nav>
        <ul>
            <li>
                <a target='_blank' rel="noreferrer" href='https://www.linkedin.com/in/julio-lopez-1020241b9/'>
                    <FontAwesomeIcon icon={faLinkedin} color='#4d4d4e'/>
                </a>
            </li>
            <li>
                <a target='_blank' rel="noreferrer" href='https://github.com/julio254'>
                    <FontAwesomeIcon icon={faGithub} color='#4d4d4e'/>
                </a>
            </li>
            <li>
                <a target='_blank' rel="noreferrer" href='https://gitlab.com/julio254'>
                    <FontAwesomeIcon icon={faGitlab} color='#4d4d4e'/>
                </a>
            </li>
        </ul>
    </div>
)

export default Sidebar